import { getAddress, type Address } from "viem";

import { USDC, type Token } from "./tokens";

/**
 * The Gneiss Pioneer USDC MetaMorpho vault on Base. Deposits here are allocated
 * by the vault curator into Morpho markets — including the CADC/USDC market the
 * looper borrows from — so supplying USDC deepens the liquidity loopers draw on.
 */
export const SUPPLY_VAULT: {
  readonly address: Address;
  readonly name: string;
  readonly asset: Token;
  readonly href: string;
} = {
  address: getAddress("0xf95C05Dbc0EcAeDBf5Fc536F1d585Aa964E36017"),
  name: "Gneiss Pioneer USDC",
  asset: USDC,
  href: "https://app.morpho.org/base/vault/0xf95C05Dbc0EcAeDBf5Fc536F1d585Aa964E36017",
};

/**
 * Minimal ERC-4626 surface used by the Supply page — deposit/withdraw plus the
 * read calls needed to size them. MetaMorpho is a superset of 4626; these are
 * the only entrypoints we touch.
 */
export const ERC4626_ABI = [
  {
    type: "function",
    name: "asset",
    stateMutability: "view",
    inputs: [],
    outputs: [{ type: "address" }],
  },
  {
    type: "function",
    name: "totalAssets",
    stateMutability: "view",
    inputs: [],
    outputs: [{ type: "uint256" }],
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [{ name: "account", type: "address" }],
    outputs: [{ type: "uint256" }],
  },
  {
    type: "function",
    name: "convertToAssets",
    stateMutability: "view",
    inputs: [{ name: "shares", type: "uint256" }],
    outputs: [{ type: "uint256" }],
  },
  {
    type: "function",
    name: "deposit",
    stateMutability: "nonpayable",
    inputs: [
      { name: "assets", type: "uint256" },
      { name: "receiver", type: "address" },
    ],
    outputs: [{ name: "shares", type: "uint256" }],
  },
  {
    type: "function",
    name: "withdraw",
    stateMutability: "nonpayable",
    inputs: [
      { name: "assets", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" },
    ],
    outputs: [{ name: "shares", type: "uint256" }],
  },
  {
    type: "function",
    name: "redeem",
    stateMutability: "nonpayable",
    inputs: [
      { name: "shares", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" },
    ],
    outputs: [{ name: "assets", type: "uint256" }],
  },
] as const;
